module.exports = __webpack_public_path__ + "assets-cabinet/img/circle-plus.485f5fc1.svg";